import { render, staticRenderFns } from "./boatTopImgBack.vue?vue&type=template&id=038396f3&"
import script from "./boatTopImgBack.vue?vue&type=script&lang=js&"
export * from "./boatTopImgBack.vue?vue&type=script&lang=js&"
import style0 from "./boatTopImgBack.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports